import { Button, Group, Stack, Table, Title } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getProductBalanceSummary } from "api/report.service";
import { navigateTo } from "common/navigation";
import { formatNZD } from "common/utils";
import React, { useEffect, useState } from "react";
import { RptProductBalanceSummary } from "types/model.types";
const AdminStockBalanceSummary: React.FC = () => {
  const [data, setData] = useState<RptProductBalanceSummary | null>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(getProductBalanceSummary());
        if (mounted && result) {
          setData(result?.data[0] ?? null);
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (!data) {
    return <Title order={4}>No data available</Title>;
  }

  return (
    <Stack>
      <Group justify="space-between" align="end" gap="sm">
        <Title order={2}>Stock Balance Summary Report</Title>
        <Button
          onClick={() => {
            navigateTo("/print/balance-summary");
          }}
          variant="gradient"
        >
          Print
        </Button>
      </Group>
      <div id="preview-content">
        <Table striped highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Th></Table.Th>
            <Table.Th>Recorded</Table.Th>
            <Table.Th>Actual</Table.Th>
            <Table.Th>Difference</Table.Th>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td className="em">Sales MTD</Table.Td>
              <Table.Td>{formatNZD(data.salesMtd)}</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(data.salesMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Cost MTD</Table.Td>
              <Table.Td>{formatNZD(data.costMtd)}</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(data.costMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Profit</Table.Td>
              <Table.Td className="em">
                {formatNZD(data.salesMtd - data.costMtd)}
              </Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(data.salesMtd - data.costMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Quantity MTD</Table.Td>
              <Table.Td>{formatNZD(data.quanMtd)}</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(data.quanMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Credits</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
              <Table.Td>{formatNZD(0)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Stock Value</Table.Td>
              <Table.Td className="em" colSpan={3}>
                {formatNZD(data.stockValue)}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </div>
    </Stack>
  );
};
export default AdminStockBalanceSummary;
